import type { Disclaimer } from "~/types/company";

export function CompanyDisclaimers({ disclaimers }: { disclaimers: Disclaimer[] }) {
	if (!disclaimers.length) return null;

	return (
		<div className="mt-8 border-t border-gray-200 pt-4 text-xs text-muted">
			<h3 className="font-semibold mb-2">Zdroje a upozornění</h3>
			<ul className="flex flex-col gap-1">
				{disclaimers.map((d) => (
					<li key={d.source}>
						<span className="font-medium">{d.source}</span>
						{d.lastUpdated && <span> (aktualizováno: {d.lastUpdated})</span>}
						{" — "}
						{d.notice}
					</li>
				))}
			</ul>
		</div>
	);
}
